import { createContext, useState } from 'react';
import { SearchableSelectInputProps, SelectItem } from 'components/select/types';
import { UseSelectGetItemPropsOptions } from 'downshift';

interface SelectContextProps<T, Item extends SelectItem<T>> {
    items: Item[];
    selectedItem: Item | null;
    selectedItems?: Item[];
    searchItems?: Item[];
    highlightedIndex: number;
    setItems: (items: Item[]) => void;
    appendItem: (item: Item) => void;
    setHighlightedIndex: (index: number) => void;
    selectAll: () => void;
    deselectAll: () => void;
    getProps: (options: UseSelectGetItemPropsOptions<Item>) => any;
    inputProps: SearchableSelectInputProps;
}

const SelectContext = createContext<SelectContextProps<any, any>>({
    items: [],
    selectedItem: null,
    selectedItems: undefined,
    highlightedIndex: -1,
    setHighlightedIndex: () => {},
    selectAll: () => {},
    deselectAll: () => {},
    appendItem: item => {},
    setItems: items => {},
    getProps: options => {},
    inputProps: {},
});

const useCreateSelectContext = <Item,>() => {
    const [items, setItems] = useState<Item[]>([]);

    const appendItem = (item: Item) => {
        setItems(items => [...items, item]);
    };

    return {
        items,
        setItems,
        appendItem,
    };
};

export type { SelectContextProps };
export { SelectContext, useCreateSelectContext };
